import React from "react";

const MultiStepSignupFormWithRole: React.FC = () => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md max-w-md mx-auto">
      <h3 className="text-lg font-semibold text-sauna-navy mb-4">
        Multi-Step Signup with Role Selection
      </h3>
      <p className="text-sauna-navy/80 mb-4">
        This component is currently in development. Please use the basic multi-step signup form for now.
      </p>
      <div className="text-center">
        <span className="text-sauna-orange font-medium">Coming Soon!</span>
      </div>
    </div>
  );
};

export default MultiStepSignupFormWithRole; 